import { Injectable } from '@angular/core';
import mpegts from 'mpegts.js';

@Injectable({ providedIn: 'root' })
export class MpegtsPlayerService {

  isTsUrl(url: string): boolean {
    if (!url) return false;
    const path = url.split('?')[0];
    return path.toLowerCase().endsWith('.ts');
  }

  createPlayers(urls: string[], videoIdPrefix: string): mpegts.Player[] {
    const players: mpegts.Player[] = [];
    if (!mpegts.isSupported() || !urls) return players;

    urls.forEach((url, index) => {
      if (!this.isTsUrl(url)) return;

      const videoElement = document.getElementById(videoIdPrefix + index) as HTMLVideoElement;
      if (!videoElement) return;

      const player = mpegts.createPlayer({ type: 'mpegts', url });
      player.attachMediaElement(videoElement);
      player.load();
      player.play();
      players.push(player);
    });

    return players;
  }

  destroyPlayers(players: mpegts.Player[]): void {
    players.forEach(player => {
      player.pause();
      player.unload();
      player.detachMediaElement();
      player.destroy();
    });
  }
}
